import './bootstrap.js';
import Alpine from 'alpinejs';
import collapse from '@alpinejs/collapse';
import intersect from '@alpinejs/intersect';

Alpine.plugin(intersect);
Alpine.plugin(collapse);

Alpine.store('ctaModal', {
  show: false,
  toggle() {
    Alpine.store('ctaModal').show = !Alpine.store('ctaModal').show;
  },
  open() {
    Alpine.store('ctaModal').show = true;
  },
  close() {
    Alpine.store('ctaModal').show = false;
  },
});

Alpine.data('languageSwitcher', () => ({
  open: false,
  toggle() {
    if (this.open) {
      return this.close();
    }

    this.$refs.button.focus();

    this.open = true;
  },
  close(focusAfter) {
    if (!this.open) return;

    this.open = false;

    focusAfter && focusAfter.focus();
  },
}));
String.prototype.rtrim = function (s) {
  if (s == null) {
    s = '\\s';
  }
  return this.replace(new RegExp('[' + s + ']*$'), '');
};
Alpine.data('header', () => ({
  y: window.scrollY,
  isMobileMenuOpen: false,

  init() {
    const scrollTo = sessionStorage.getItem('scrollTo');
    if (scrollTo == null) {
      return;
    }
    sessionStorage.removeItem('scrollTo');
    this.scrollTo(scrollTo);
  },

  scrollTo(id) {
    document.querySelector(`[data-section="${id}"]`)?.closest('section')?.scrollIntoView({ behavior: 'smooth' });
  },
  onMenuClick(e) {
    this.isMobileMenuOpen = false;
    const url = e.target.href?.split('#');
    if (url == null) {
      return;
    }

    const currentUrl = window.location.href.rtrim('/');

    if (url[0].rtrim('/') === currentUrl) {
      this.scrollTo(url[1]);
      return;
    }
    sessionStorage.setItem('scrollTo', url[1]);
    window.location.href = url[0];
  },
}));

Alpine.start();
